import bus from '../../utils/bus'
import { QtReportCloseTags } from '@/layout/utils/report-qt.js'

const getMenuIds = (tags, menus) => {
  let ids = []
  tags.forEach(v => {
    let menu = menus[v]
    if (menu && menu.id) {
      ids.push(menu.id)
    }
  })
  return ids
}

const openMenu = (route) => {
  // 2022-10-31 页签存在的情况下，从一个页签里面的某个功能跳转到其他页面（主页、详情页），左侧菜单未定位
  const currentRoute = tagsView.state.visitedViews.find(t => t.tag === route.meta.tag)
  currentRoute && bus.$emit('TAB_CLICK', currentRoute.path, currentRoute.tag)
}


const tagsView = {
  state: {
    closedTag: '',
    visitedViews: [],
    cachedViews: [],
    logs: {}
  },
  mutations: {
    ADD_VISITED_VIEWS (state, { route, menuId }) {
      if (!route.name || !route.meta.tag || state.visitedViews.some(v => v.path === route.fullPath)) {
        openMenu(route)
        return
      }
      let view = state.visitedViews.find(v => v.tag === route.meta.tag)
      // 2022-12-12 判断当前路由是否缓存
      const isKeepAlive = route.meta.isKeepAlive
      if (view) {
        view.path = route.fullPath
        view.closeTag = !!route.meta.closeTag
        view.pageType = route.meta.pageType
        if (!view.names.includes(route.name)) {
          view.names.push(route.name)
          if (isKeepAlive !== false) {
            state.cachedViews.push(route.name)
          }
        }
        openMenu(route)
        return
      }
      if (route.meta.layout) {
        route.meta.layout = false
      }
      let tag = route.meta.tag
      let title = route.meta.tagTitle
      state.closedTag = ''
      state.visitedViews.push(Object.seal({
        path: route.fullPath,
        names: [route.name],
        menuId,
        tag,
        title,
        closeTag: !!route.meta.closeTag,
        playout: route.meta.playout,
        pageType: route.meta.pageType
      }))
      if (isKeepAlive !== false) {
        state.cachedViews.push(route.name)
      }
      let time = '' + Date.now()
      state.logs[menuId] = time
      bus.$emit('GLOBAL_MENU_OPEN', { tag, menuId, title, time })
    },
    DEL_VISITED_VIEWS (state, view) {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.tag === view.tag) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      const layout = view.playout
      const hasLayout = state.visitedViews.some(v => layout === v.playout)
      state.cachedViews = state.cachedViews.filter(v => {
        if (hasLayout) {
          return !view.names.includes(v)
        }
        return !view.names.includes(v) && v !== layout
      })
    },
    DEL_OTHERS_VIEWS: (state, view) => {
      state.visitedViews = state.visitedViews.filter(v => v.tag === view.tag || v.tag === '/')
      const layout = view.playout
      state.cachedViews = state.cachedViews.filter(v => v === 'home' || v === layout || view.names.includes(v))
    },
    CLEAR_VISITED_VIEWS (state) {
      state.closedTag = ''
      state.visitedViews = state.visitedViews.filter(v => v.tag === '/')
      state.cachedViews = ['home']
    },
    SET_CLOSED_TAG (state, path) {
      state.closedTag = path
    },
    // coo 需求
    CHANGE_VISITED_VIEWS_TITLE (state, { path, title }) {
      let view = state.visitedViews.find(v => v.tag === path)
      if (view) {
        view.title = title
      }
    },
  },
  actions: {
    addVisitedViews ({ commit, rootState, state }, route) {
      let layout = route.meta.playout
      if (layout && !state.cachedViews.includes(layout)) {
        state.cachedViews.push(layout)
      }
      let menu = rootState.menus[route.meta.tag] || { id: '2820215716730110' }
      route.meta.tagTitle = menu.title || route.meta.title
      commit('ADD_VISITED_VIEWS', { route, menuId: menu.id || '' })
    },
    delVisitedViews ({ commit, rootState, state }, view) {
      let tag = view.tag
      commit('queryTable/unregisterModule', [tag])
      commit('DEL_VISITED_VIEWS', view)
      if (view.path === location.hash.replace('#', '')) {
        commit('SET_CLOSED_TAG', tag)
      }
      let menu = rootState.menus[tag]
      if (menu && menu.id) {
        bus.$emit('GLOBAL_MENU_CLOSE', [menu.id])
      }
      QtReportCloseTags(tag, 'delVisitedViews')
      return Promise.resolve(state.visitedViews)
    },
    delOthersViews ({ commit, rootState, state }, view) {
      let tags = []
      state.visitedViews.forEach(v => {
        if (v.tag !== view.tag) {
          tags.push(v.tag)
        }
      })
      commit('queryTable/unregisterModule', tags)
      commit('DEL_OTHERS_VIEWS', view)
      bus.$emit('GLOBAL_MENU_CLOSE', getMenuIds(tags, rootState.menus))
      QtReportCloseTags(tags, 'delOthersViews')
    },
    delAllViews ({ commit, rootState, state }) {
      let tags = state.visitedViews.map(v => v.tag)
      commit('queryTable/unregisterModule', tags)
      commit('CLEAR_VISITED_VIEWS')
      bus.$emit('GLOBAL_MENU_CLOSE', getMenuIds(tags, rootState.menus))
      QtReportCloseTags(tags, 'delAllViews')
    }
  }
}

export default tagsView



// WEBPACK FOOTER //
// ./src/public/store/modules/tagsView.js